import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PwaService {

    private deferredPrompt: any;

    constructor() {
        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            this.deferredPrompt = event;
            console.log('PwaServiceService:: pwa installation event stored for future use...')
        });
    }

    get isPromptAvailable(): boolean {
        return !!this.deferredPrompt;
    }

    public promptInstall() {
        return new Promise((resolve, reject) => {
            if (!this.deferredPrompt) { reject(false) }
            this.deferredPrompt
                .prompt()
                .then(() => {
                    this.deferredPrompt.userChoice.then((choiceResult: any) => {
                        this.deferredPrompt = null;
                        resolve(choiceResult.outcome === 'accepted');
                    });
                });
        })
    }

    public installPWA(): void {
        this.deferredPrompt.prompt();

    }

}
